import { createAsyncActions } from '~/utils/store';

export const SAVE = createAsyncActions('@@DRAWER_MONTHLY_PAYMENT/SAVE'); //SET_MONTHLY_PAID
export const LOAD_LOGS = createAsyncActions('@@DRAWER_MONTHLY_PAYMENT/LOAD_LOGS');

export const save = (data) => ({
    type: SAVE.INIT,
    payload: {
        request:{
            method: 'put',
            url:`/monthly/payments/${data.id}`,
            data,
            showLoading: false
        }
    },
    id: data.id
});

export var loadLogs = function(id) {
    return {
        type: LOAD_LOGS.INIT,
        payload: {
            request: {
                method: 'get',
                url: '/monthly/payments/' + id + '/logs',
                showLoading: false
            }
        }
    };
};